import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { phoneNumberFormatter, useTranslatedText } from '@dreryk/react-common';

type PhoneProps = {
   readonly phoneNumber: PatientSimple['phoneNumber'];
};

export const PhoneCell = (props: PhoneProps): JSX.Element => {
   const { phoneNumber } = props;
   const formattedPatientPhone = phoneNumberFormatter(phoneNumber);
   const patientPhoneTranslatedLabel = useTranslatedText(formattedPatientPhone);

   return <>{patientPhoneTranslatedLabel.text}</>;
};
